import { render, staticRenderFns } from "./mobile-part-2.vue?vue&type=template&id=4f1eaeca&scoped=true"
import script from "./mobile-part-2.vue?vue&type=script&lang=js"
export * from "./mobile-part-2.vue?vue&type=script&lang=js"
import style0 from "./mobile-part-2.vue?vue&type=style&index=0&id=4f1eaeca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1eaeca",
  null
  
)

export default component.exports